/**
 *
 * @description
 * This needs to be manually mantained as new groups are
 * Defined in our consent management platform (Onetrust).
 */
const consentGroups = {
  necessary: 'C0001',
  performance: 'C0002',
  functional: 'C0003',
  targeting: 'C0004',
};

/**
 *
 * @export
 * @class consentManagement
 */
export default class consentManagement {

  callBackFired = false;
  forceCallback = false;

  /**
   *Creates an instance of consentManagement.
   * @param {*} callBack
   * @memberof consentManagement
   */
  constructor(callBack) {

    // Abort if no onetrust.
    if (!window.OptanonWrapper) {
      callBack();
      this.callBackFired = true;
      return false;
    }

    // Primmed visitor.
    if (window.OnetrustActiveGroups && hasConsentGroup("necessary")) {
      this.callBackFired = true;
      callBack();
    }
    // Unprimmed visitor.
    else {
      this.forceCallback = true;
    }

    // Add previous functions to current callback.
    const prev_func = window.PomOnConsentChanged ? window.PomOnConsentChanged : () => {};
    window.PomOnConsentChanged = () => {
      prev_func.call(this);
      callBack();
      this.callBackFired = true;
    };

    // Update on consent change.
    window.OptanonWrapper = () => {
      // Force call back on unprimmed visitor.
      if (this.forceCallback) {
        window.PomOnConsentChanged();
      }
      // Trigger on consent change.
      if (window.Optanon && window.Optanon.OnConsentChanged) {
        Optanon.OnConsentChanged(() => {
          if (this.callBackFired) {
            //location.reload();
          }
          else {
            window.PomOnConsentChanged();
          }
        })
      }
    };

  }

}

/**
 *
 * @export
 * @param {string} GroupName
 * @returns boolean
 */
export function hasConsentGroup(GroupName) {
  const activeGroups = window.OnetrustActiveGroups !== undefined ? OnetrustActiveGroups.split(',') : new Array(consentGroups[GroupName]);
  return consentGroups[GroupName] ? activeGroups.includes(consentGroups[GroupName]) : false
}

/**
 *
 * @export
 * @param {string} GroupId
 * @returns boolean
 */
export function hasConsentGroupId(GroupId) {
  const activeGroups = window.OnetrustActiveGroups !== undefined ? OnetrustActiveGroups.split(',') : new Array(GroupId);
  return activeGroups.includes(GroupId)
}


// WEBPACK FOOTER //
// ./scripts/util/consent-management.js